import { Component } from '@angular/core';

/* 
import * as $ from ‘jquery’;
import * as jQuery from ‘jquery’;
*/

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css']
})
export class AppComponent {
    constructor(){
        localStorage.removeItem('firebase:previous_websocket_failure');
    }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts